import client from '../../client';
import type {
  IGetAiAgentCompanyListParams,
  IGetAiAgentServiceOperationSettingsHistoryParams,
  IAiAgentServiceOperationSettings,
  IPutAiAgentServiceOperationSettingsParams,
} from './types';

export const aiAgentCompanyApis = {
  getAiAgentCompanyList: (data: IGetAiAgentCompanyListParams) => client.get(`/ai-agent/companies`, { params: data }),
  getAiAgentServiceOperationSettings: (companyId: number) =>
    client.get<IAiAgentServiceOperationSettings>(`/ai-agent/companies/${companyId}/settings`),
  putAiAgentServiceOperationSettings: (data: IPutAiAgentServiceOperationSettingsParams) =>
    client.put(`/ai-agent/companies/${data.companyId}/settings`, data.data),
  getAiAgentServiceOperationSettingsHistory: (params: IGetAiAgentServiceOperationSettingsHistoryParams) =>
    client.get(`/ai-agent/companies/${params.companyId}/settings/history`, {
      params: {
        page: params.page,
        size: params.size,
        startDate: params.startDate,
        endDate: params.endDate,
        managerKeyword: params.managerKeyword,
      },
    }),
  patchAiAgentFeedback: (data: { companyId: number; data: { feedbackManageYn: 'Y' | 'N' } }) =>
    client.patch(`/ai-agent/companies/${data.companyId}/settings/feedback-manage`, data.data),
};
